// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../confirm_modal"
import "../qty_stepper"
import "../checkout_toggle"
import "../places_autocomplete"
import "../order_type_toggle"
import "../address_picker"
import "../toast"
import "../delivery_timer"
import "../delivery_date_toggle"
import "../auth_slider"
import "../address_tabs"
import "../order_search"
import "../wholesale_price_editor"
import "../tag_select"
import "../reports_filter"
import "../packing_report"
import "../profile_menu"

Rails.start()
Turbolinks.start()
ActiveStorage.start()
